import React from "react";
import Chart from "react-apexcharts";
import Cookies from "js-cookie";

function ChartPlaing(data) {
  // const series = [{
  //   name: 'Ads On',
  //   data: [44, 55, 41, 67]
  // }, {
  //   name: 'Ads Extra',
  //   data: [13, 23, 20, 8]
  // }, {
  //   name: 'No Ads',
  //   data: [11, 17, 15, 15]
  // }];

  var data_show = [];
  var setdata_ads_extra = [];
  var setdata_ads_on = [];
  var setdata_no_ads = [];


  var mL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var mL_sorted = [];
  // console.log(data.data);
  console.log("=========");
  if (Cookies.get("operator_id") === "3") {
    for (let i = 0; i < mL.length; i++) {
      for (let r = 0; r < data.data.length; r++) {
        var temp_split = data.data[r].data_year_month.split("/");
        if (i === parseInt(temp_split[1] - 1)) {
          // console.log(parseInt(temp_split[1] - 1));
          // console.log(`index data: ${r}`);
          // console.log(`month: ${mL[i]}`);
          // console.log(`has data ${data.data[r].data_year_month}`);
          setdata_ads_extra.push(data.data[r].ads_extra);
          setdata_ads_on.push(data.data[r].ads_on);
          setdata_no_ads.push(data.data[r].no_ads);
          mL_sorted.push(mL[i])
        } 
        // else if ( 
        //    r <=  data.data.length   && i != parseInt(temp_split[1] - 1)  && i != 11 && r < 1
        // ) {
          
        //   console.log(`index data: ${r}`);
        //   console.log(`month: ${mL[i]}`);
        //   console.log(`empty data ${data.data[r].data_year_month}`);
        //   setdata_ads_extra.push(0);
        //   setdata_ads_on.push(0);
        //   setdata_no_ads.push(0);
        // } 
        // else if  (r ===  data.data.length - 1 && i != parseInt(temp_split[1] - 1)  && i != 11) {

        // }
        console.log("-------------------------------------");
      }
    }
    console.log("=========");
    console.log("=======================");
    console.log(setdata_ads_on);
    console.log(setdata_ads_extra);
    console.log(setdata_no_ads);
    console.log("=======================");
    data_show = [{
      name: 'Ads On',
      data: setdata_ads_on
    }, {
      name: 'Ads Extra',
      data: setdata_ads_extra
    }, {
      name: 'No Ads',
      data: setdata_no_ads
    }];
    const series = data_show;
    const options = {
      chart: {
        type: 'bar',
        height: 650,
        stacked: true,
        // toolbar: {
        //   show: true
        // },
        zoom: {
          enabled: true
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#040E9A', '#E8CD00', '#37AB74'],
      fill: {
        colors: ['#040E9A', '#E8CD00', '#37AB74'],
      },
      responsive: [{
        // breakpoint: 480,
        // options: {
        //   legend: {
        //     position: 'bottom',
        //     offsetX: -10,
        //     offsetY: 0
        //   }
        // }
      }],
      plotOptions: {
        bar: {
          borderRadius: 8,
          horizontal: false,
        },
      },
      xaxis: {
        type: 'category',
        // categories: xaxis_categories,
        categories: mL_sorted,
      },
      legend: {
        position: 'top',
        offsetY: 0,
        offsetX: 30
      },
      fill: {
        opacity: 1
      }
    };


    return (
      <Chart options={options} series={series} height={650} type="bar" />
    )
  }
}

export default ChartPlaing